module.exports = __webpack_public_path__ + "static/media/friends.1ca8d302.png";